<div [formGroup]="form()" class="flex flex-col gap-3">
  <div class="flex flex-col">
    <span class="text-lg">{{ 'pages.campaignForm.sections.basics.teamSelectLabel' | translate }}</span>
    <div class="text-shikenso-purple-base-60 text-sm">
      {{ 'pages.campaignForm.sections.basics.teamSelectDescription' | translate }}
    </div>
  </div>

  @if (loading()) {
    <ngx-skeleton-loader class="h-12" [theme]="{ width: '648px', height: '48px', 'border-radius': '100vw' }" />
  } @else {
    <div class="w-full">
      <mat-form-field class="w-full mat-form-field-with-icon">
        <mat-select
          panelClass="custom-select-panel"
          formControlName="team"
          [hideSingleSelectionIndicator]="true"
          [placeholder]="'pages.campaignForm.sections.basics.selectOrAddTeam' | translate"
        >
          <mat-select-trigger>
            <ng-container *ngTemplateOutlet="teamOption; context: { $implicit: form().controls.team.value }" />
          </mat-select-trigger>

          @if (canCreateTeam()) {
            <mat-option class="mat-option-add-option" (onSelectionChange)="onAddTeamOptionSelected($event)">
              <div class="flex items-center justify-center gap-2 w-full">
                <app-icon src="icons/plus.svg" class="w-5 h-5" />
                <span>{{ 'pages.campaignForm.sections.basics.addTeam' | translate }}</span>
              </div>
            </mat-option>
          }

          @if (selectedTeam()) {
            <mat-option class="mat-option-add-option" (onSelectionChange)="onClearTeamOptionSelected($event)">
              <div class="flex items-center justify-center gap-2 w-full">
                <app-icon src="icons/close.svg" class="w-5 h-5" />
                <span>{{ 'shared.clear' | translate }}</span>
              </div>
            </mat-option>
          }

          <mat-option>
            <ngx-mat-select-search
              [formControl]="teamSearchControl"
              [placeholderLabel]="'pages.campaignForm.sections.basics.searchTeam' | translate"
              [noEntriesFoundLabel]="'pages.campaignForm.sections.basics.noTeamsFound' | translate"
            >
              <app-icon ngxMatSelectSearchClear src="icons/close.svg" alt="close" [size]="16" />
            </ngx-mat-select-search>
          </mat-option>

          @for (team of filteredTeams(); track team.id) {
            <mat-option [value]="team">
              <ng-container *ngTemplateOutlet="teamOption; context: { $implicit: team }" />
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
</div>

<ng-template #teamOption let-item>
  <div class="flex items-center gap-2 max-w-[300px]">
    <app-icon-badge
      [content]="item?.iconId"
      [fallbackText]="item?.name"
      [size]="32"
      [iconSize]="32"
      [fontSize]="16"
      [borderRadius]="100"
    />
    <div class="whitespace-nowrap overflow-hidden text-ellipsis flex-1">
      {{ item?.name }}
    </div>
  </div>
</ng-template>
